export default __webpack_public_path__ + "images/f930072dd3beb7fadfcc979b0d6a3694-fineart.webp";